var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHistory = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.758 2.758 1.96 1.96A.563.563 0 0 0 1 2.357v2.58c0 .312.25.563.563.563h2.58a.563.563 0 0 0 .398-.96l-.721-.723a4.501 4.501 0 1 1 .61 6.877.752.752 0 0 0-.861 1.23 6 6 0 1 0-.81-9.166ZM7 4a.561.561 0 0 0-.563.563V7c0 .15.06.293.165.398l1.687 1.688a.562.562 0 0 0 .795-.795L7.56 6.768V4.563A.561.561 0 0 0 6.998 4H7Z"
  })));
};
export default SvgHistory;